import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Spinner } from '@feathr/components';

export default function LoadingMessage(): JSX.Element {
  const { t } = useTranslation();

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
        <Spinner />
        <p>{t('Generating report... This may take a few moments.')}</p>
      </div>
    </div>
  );
}
